import React from "react";
import ServiceHeader from "../../component/ServiceHeader";
import "../../views/PageContent.css";
import { useNavigate } from "react-router-dom";

// Icon components using inline SVG
const MicIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full text-blue-600">
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" x2="12" y1="19" y2="22" />
  </svg>
);

const MessageIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#2563eb' }}>
  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
</svg>
);

const OPDRoundsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 48, height: 48, color: 'purple'}}>
    <path d="M18 10h-8v5h8v-5z" />
    <path d="M10 10V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4" />
    <circle cx="7" cy="19" r="2" />
    <circle cx="13" cy="19" r="2" />
    <path d="M7 17V5" />
    <path d="M13 17v-4" />
  </svg>
);

const IPDRoundsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 48, height: 48, color: 'gray'}}>
    <rect x="3" y="7" width="18" height="14" rx="2" ry="2" />
    <path d="M12 4h4a2 2 0 0 1 2 2v2" />
    <line x1="12" y1="11" x2="12" y2="17" />
    <line x1="9" y1="14" x2="15" y2="14" />
    <path d="M3 13h3" />
    <path d="M18 13h3" />
  </svg>
);

const ImageAnalysisIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 48, height: 48, color: '#e7e73c'}}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 4 22" />
  </svg>
);

const FileIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#16a34a' }}>
  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
  <polyline points="14 2 14 8 20 8" />
</svg>
);

const VideoIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#9333ea' }}>
  <path d="M23 7l-7 5 7 5V7z" />
  <rect x="1" y="5" width="22" height="14" rx="2" ry="2" />
</svg>
);

const RobotIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#9333ea' }}>
  <path d="M12 8V4H8" />
  <rect width="16" height="12" x="4" y="8" rx="2" />
  <path d="M2 14h2" />
  <path d="M20 14h2" />
  <path d="M15 13v2" />
  <path d="M9 13v2" />
</svg>
);

const DatabaseIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#f97316' }}>
  <ellipse cx="12" cy="5" rx="9" ry="3" />
  <path d="M3 5V19A9 3 0 0 0 21 19V5" />
  <path d="M3 12A9 3 0 0 0 21 12" />
</svg>
);

const ShieldIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#dc2626' }}>
  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
</svg>
);

const PrescriptionIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#0ea5e9' }}>
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
  <path d="M14 2v6h6" />
  <path d="M9 13l2 2 4-4" />
</svg>
);

const Healthcare = () => {
  const navigate = useNavigate();
  const useCases = [
    {
        icon: <MicIcon />,
        title: "Dictation",
        description: "Automated conversion of medical conversations to structured text.",
        details: [
          "Real-time audio to text conversion",
          "Medical terminology recognition",
          "Automatic document formatting"
        ]
      },
    {
      icon: <MessageIcon />,
      title: "Transcription",
      description: "Automated conversion of medical conversations to structured text.",
      details: [
        "Real-time audio to text conversion",
        "Medical terminology recognition",
        "Automatic document formatting"
      ]
    },
    {
      icon: <ImageAnalysisIcon />,
      title: "Image Analysis",
      description: "Advanced medical image interpretation and reporting.",
      details: [
        "X-ray and CT scan analysis",
        "Automated findings detection",
        "Comparative image analysis",
        "Detailed and structured notes like analysis"
      ]
    },
    {
      icon: <VideoIcon />,
      title: "Radiology Video Analysis",
      description: "Intelligent analysis of medical imaging videos.",
      details: [
        "Real-time video scanning",
        "Anomaly detection",
        "Comparative movement analysis",
        "MRI videos analysis"
      ]
    },
    {
      icon: <FileIcon />,
      title: "Report Analysis",
      description: "Comprehensive medical report interpretation and summarization.",
      details: [
        "Complex report parsing",
        "Key findings extraction",
        "Risk assessment",
        "Report summarization"
      ]
    },
    {
      icon: <DatabaseIcon />,
      title: "Patient Details Management",
      description: "Intelligent patient information processing and retrieval.",
      details: [
        "Comprehensive patient history",
        "Risk profile generation",
        "Personalized health insights",
        "Summarized diagnosis"
      ]
    },
    {
      icon: <RobotIcon />,
      title: "AI Second Opinion",
      description: "AI-powered medical consultation and diagnostic support.",
      details: [
        "Cross-referencing medical databases",
        "Differential diagnosis generation",
        "Treatment recommendation"
      ]
    },
    {
      icon: <ShieldIcon />,
      title: "Insurance Pre-Approval Form",
      description: "Automated insurance pre-authorization document generation.",
      details: [
        "Intelligent form completion",
        "Compliance checking",
        "Rapid submission preparation",
        "Minimal denial rate"
      ]
    },
    {
      icon: <ShieldIcon />,
      title: "Insurance Claim Form Generation",
      description: "Streamlined medical insurance claim document creation.",
      details: [
        "Automatic claim form population",
        "Billing code verification",
        "Error reduction"
      ]
    },
    {
      icon: <PrescriptionIcon />,
      title: "Prescription Generation",
      description: "AI-assisted prescription writing and management.",
      details: [
        "Medication recommendation",
        "Dosage calculation",
        "Drug interaction checking"
      ]
    },
    {
      icon: <OPDRoundsIcon />,
      title: "OPD Rounds Assistant",
      description: "AI support for Outpatient Department clinical workflows.",
      details: [
        "Patient queue management",
        "Quick consultation summaries",
        "Preliminary diagnostic support"
      ]
    },
    {
      icon: <IPDRoundsIcon />,
      title: "IPD Rounds Assistant",
      description: "AI-enhanced support for Inpatient Department clinical processes.",
      details: [
        "Patient condition tracking",
        "Treatment progress monitoring",
        "Comprehensive round summaries"
      ]
    }
  ];

  return (
    <div className="wrapper">
      {<ServiceHeader title="AI-Powered Healthcare Solutions" />}
       <div style={{ 
          minHeight: '100vh', 
          display: 'flex', 
          flexDirection: 'column', 
          backgroundColor: '#f9fafb' 
        }}>
      {/* Use Cases Section */}
      <section style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '4rem 1.5rem' 
      }}>
        <h2 style={{ 
          fontSize: '1.875rem', 
          fontWeight: 'bold', 
          textAlign: 'center', 
          marginBottom: '3rem' 
        }}>
          Our Comprehensive AI Healthcare Solutions
        </h2>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(4, minmax(250px, 1fr))', 
          gap: '1.5rem' 
        }}>
          {useCases.map((useCase, index) => (
            <div 
              key={index} 
              style={{ 
                backgroundColor: 'white', 
                padding: '1.5rem', 
                borderRadius: '0.5rem', 
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)', 
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '1rem' 
              }}>
                {useCase.icon}
                <h3 style={{ 
                  marginLeft: '1rem', 
                  fontSize: '1.25rem', 
                  fontWeight: 600 
                }}>
                  {useCase.title}
                </h3>
              </div>
              <p style={{ 
                color: '#4b5563', 
                marginBottom: '1rem' 
              }}>
                {useCase.description}
              </p>
              
              <div style={{ marginTop: '1rem' }}>
                {useCase.details.map((detail, detailIndex) => (
                  <div 
                    key={detailIndex} 
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      marginBottom: '0.5rem' 
                    }}
                  >
                    <span style={{ 
                      color: '#10b981', 
                      marginRight: '0.5rem' 
                    }}>
                      ✓
                    </span>
                    <span>{detail}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    
    <section style={{ 
  maxWidth: '1200px', 
  margin: '0 auto', 
  padding: '4rem 1.5rem' 
}}>
  <div style={{
    display: 'flex',
    gap: '2rem',
    alignItems: 'stretch',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }}>
    {/* Left Side: Title + Buttons */}
    <div style={{
      backgroundColor: 'white',
      padding: '2rem',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      flex: 1,
      minWidth: '300px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }}>
      <h2 style={{
        fontSize: '1.875rem',
        fontWeight: 'bold',
        marginBottom: '2rem',
        textAlign: 'left'
      }}>
        Our Healthcare Demo
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {[{
          label: "AHS - Actual Healthcare System Bot",
          path: "/AhsChatbot"
        }, {
          label: "Insurance Bot",
          path: "/InsuranceBot"
        }].map((btn, index) => (
          <button
            key={index}
            style={{
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '0.75rem 2rem',
              borderRadius: '9999px',
              fontWeight: 'bold',
              border: 'none',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              minWidth: '200px',
              textAlign: 'center'
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#6996f8')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#2563eb')}
            onClick={() => window.open(btn.path, "_blank")}
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>

    {/* Right Side: Download Card */}
    <div style={{
      backgroundColor: 'white',
      padding: '2rem',
      borderRadius: '0.5rem',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      flex: 1,
      minWidth: '300px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"
          viewBox="0 0 24 24" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <line x1="10" y1="9" x2="9" y2="9" />
        </svg>
        <h3 style={{ marginLeft: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>Download Healthcare Deck</h3>
      </div>
      <p style={{ color: '#4b5563', marginBottom: '1rem' }}>
        Access the PDF for complete overview of Healthcare AI.
      </p>
      <a
        href="https://stlangutilitydev.blob.core.windows.net/uploadfiles/Healthcare-deck.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#7c3aed',
          color: 'white',
          padding: '0.5rem 1.5rem',
          borderRadius: '0.375rem',
          fontWeight: '600',
          fontSize: '0.95rem',
          textDecoration: 'none',
          alignSelf: 'start'
        }}
      >
        Download PDF
      </a>
    </div>
  </div>
</section>


    </div>
    </div>
  );
};

export default Healthcare;
